<script>
    import { navigate } from 'svelte-routing';
    import Header from "../components/Header.svelte";
    import GoogleMap from "../utils/GoogleMap.svelte";
    import ResponsiveTable from '../utils/responsivetable.svelte';
    import { getToken } from '../utils/Fetching.js';
    import { user_store, user_info_store } from '../stores.js';
    import { state_codes } from '../globals.js';
    import { formatPhoneNumber, getFullState, formatDate, check_access_able, formatter, sort_functions } from '../utils/format.js';
    import Loading from '../components/Loading.svelte';
    import { get_user_info } from '../init';


    let profile = {};
    let myself = {};
    let is_loaded = false;
    let from_date, to_date;
    let refresh = false;

    const { auth_type, auth_token, domain_code } = getToken();

    const update_stats_data = (services) => {
        let total_prices = 0, total_crew_prices = 0, total_profit = 0;
        total_prices = services.reduce((acc, service) => {
            return acc + service.total_service_price;
        }, 0);
        total_crew_prices = services.reduce((acc, service) => {
            return acc + ((service.crew_role === 'contractor' || profile.role === 'contractor') ? parseFloat(service.total_contractor_price || 0) : 0);
        }, 0);
        total_profit = services.reduce((acc, service) => {
            return acc + service.profit;
        }, 0);
        statistic_data = {
            'id': 'statistic', 'cn': '', 'csv_cn': '', 'ad': '', 'cr': '', 'csv_cr': '', 'd': '', 'st': '', 'p': formatter.format(total_prices), 'ud': `$${parseFloat(total_crew_prices).toFixed(2)}`, 'pt': `$${parseFloat(total_profit).toFixed(2)}`
        };
    }

    $: {
        const date_filtered_services = services_data.filter(service => from_date <= service.d.split(' - ')[0] && service.d.split(' - ')[0] <= to_date);
        update_stats_data(date_filtered_services);
    }

    let date_value = '';
    const refresh_user_info = async (_refresh=false) => {
        refresh = _refresh;
        const uid = myself.user.id;
        if (refresh || !is_loaded) {
            get_user_info(uid);
        }
    }
    user_store.subscribe(async (value) => {
        myself = value;
        await refresh_user_info();
    });

    // let services_table_header_config = [
    //     {'t': 'Date/Time', 'fm': 'd', 'csv': 'd', 'a': true},
    //     {'t': 'Client', 'fm': 'cn', 'csv': 'csv_cn', 'a': false},
    //     {'t': 'Address', 'fm': 'ad', 'csv': 'csv_ad', 'a': false},
    //     {'t': 'Crew', 'fm': 'cr', 'csv': 'csv_cr', 'a': false},
    //     {'t': 'Service Type', 'fm': 'st', 'csv': 'st', 'a': true},
    //     {'t': 'Price', 'fm': 'p', 'csv': 'p', 'a': true},
    //     {'t': 'Contractor Price', 'fm': 'ud', 'csv': 'ud', 'a': true},
    //     {'t': 'Profit', 'fm': 'pt', 'csv': 'pt', 'a': true}
    // ];
    let services_data = [];
    let statistic_data = {};
    let show_items = [
        {
            "id": "show",
            "i": "fas fa-eye",
            "s": "color: #1c54b2;",
            "f": (id) => { navigate("/job_review/" + id); },
            'middle_click_link': (id) => { window.open('#/Job_Review?jid=' + id, '_blank'); }
        }
    ];

    let invoices_table_header_config = [
        {'t': 'Invoice Number', 'fm': 'in', 'a': true},
        {'t': 'Paid Value', 'fm': 'pv', 'a': true},
        {'t': 'Balance Due', 'fm': 'db', 'a': true},
        {'t': 'Address', 'fm': 'addr', 'a': true},
        {'t': 'Date', 'fm': 'd', 'a': true},
    ];
    let invoices_data = [];
    let invoice_show_items = [
        {
            "id": "show",
            "i": "fas fa-eye",
            "s": "color: #1c54b2;",
            "f": (id) => { navigate("/invoice_review/" + id); },
            'middle_click_link': (id) => { window.open('/invoice_review/' + id, '_blank'); }
        }
    ];

    user_info_store.subscribe(value => {
        console.log("===", value);
        if (value.profile && value.services) {
            profile = value.profile;
            // if (!refresh) {
            //     if (profile.role === 'contractor' || profile.role === 'employee' || profile.role === 'landscaper') {
            //         services_table_header_config[1].a = true;
            //         services_table_header_config.splice(1, 1);
            //         services_table_header_config.splice(2, 1);
            //         if (profile.role === 'employee') {
            //             services_table_header_config.splice(3, 2);
            //         }
            //     } else {
            //         services_table_header_config[3].a = true;
            //         services_table_header_config.splice(1, 1);
            //     }
            // }
            if (profile.state.length === 2) {
                profile.state = Object.keys(state_codes).find(code => state_codes[code] == profile.state);
            }

            const services = [];
            const invoices = [];
            for (let i = 0; i < value.services.length; i ++) {
                const service = value.services[i];
                if (service.invoice) {
                    invoices.push({
                        'id': service.invoice.invoice_number,
                        'in': service.invoice.invoice_number.toUpperCase(),
                        'd':  formatDate(service.invoice.created_at),
                        'addr': `${service.job.address}, ${service.job.city}, ${getFullState(service.job.state)}`,
                        'pv': `$${service.invoice.paid_amount}`,
                        'db': `$${service.invoice.due_balance}`,
                    });
                }

                if (service.job.status !== 'pending') {
                    let crews = '';
                    let csv_crews = [];
                    let crew_role = '';
                    if (profile.role !== 'contractor' && profile.role !== 'employee' && profile.role !== 'landscaper') {
                        for (let j = 0; j < service.crews.length; j ++) {
                            const crew = service.crews[j];
                            crew_role = crew.role;
                            crews += `<a sortValue='${crew.first_name} ${crew.last_name}' href='/#/Redirect_User_Review?uid=${crew.id}' style='display: block;'>${crew.first_name} ${crew.last_name}</a>`;
                            csv_crews.push(`${crew.first_name} ${crew.last_name}`);
                        }
                    }
                
                    const full_address = `${service.job.address}, ${service.job.city}, ${getFullState(service.job.state)}`;
                    const profit = parseFloat(service.job.total_service_price) - ((crew_role === 'contractor' || profile.role === 'contractor') ? parseFloat(service.job.total_contractor_price || 0) : 0);
                    services.push({
                        'id': service.job.id,
                        'cn': `<a sortValue='${service.client.first_name} ${service.client.last_name}' href='/#/Redirect_User_Review?uid=${service.client.id}'>${service.client.first_name} ${service.client.last_name}</a>`,
                        'csv_cn': `${service.client.first_name} ${service.client.last_name}`,
                        'ad': full_address,
                        'csv_ad': `"${full_address}"`,
                        'cr': crews ? crews : 'Not assigned',
                        'csv_cr': `"${csv_crews.join(', ')}"`,
                        'd': `${formatDate(service.job.service_date)} - ${service.job.time_preference}`,
                        'st': service.job.service_type,
                        'p': `$${parseFloat(service.job.total_service_price).toFixed(2)}`,
                        'total_service_price': service.job.total_service_price,
                        'ud': (crew_role === 'contractor' || profile.role === 'contractor') ? `$${parseFloat(service.job.total_contractor_price).toFixed(2)}` : '-',
                        'total_contractor_price': service.job.total_contractor_price,
                        'pt': `$${parseFloat(service.job.total_service_price - ((crew_role === 'contractor' || profile.role === 'contractor') ? service.job.total_contractor_price : 0)).toFixed(2)}`,
                        'profit': profit,
                        'crew_role': crew_role
                    });
                }
            }
            services.sort((a, b) => {
                if (a.d < b.d) return 1;
                else if (a.d == b.d) return 0;
                else return -1;
            });
            services_data = services;
            invoices_data = invoices;
            update_stats_data(services);
            is_loaded = true;
        }
    });
</script>


<Header />

<div class="formholder">
	<!-- <div class="pagetitle">
	    Your Profile
	</div> -->

    {#if is_loaded}
    <div class="contentholder">
        <div class="section basic">
            <div class="sectionsubtitle">Basic</div>
            <div class="sectioninfo row">
                <div class="column">
                    <div class="infoitem">
                        <div class="infoitemtitle">Name:</div>
                        <div class="infoitemvalue">{`${profile.first_name} ${profile.last_name}`}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">User Type:</div>
                        <div class="infoitemvalue" style='text-transform: capitalize;'>{profile.role === 'landscaper' ? 'owner' : profile.role}</div>
                    </div>
                    {#if (profile.role === 'employee' || profile.role === 'contractor') && profile.job_title !== ''}
                        <div class="infoitem">
                            <div class="infoitemtitle">Job Title:</div>
                            <div class="infoitemvalue" style='text-transform: capitalize;'>{profile.job_title}</div>
                        </div>
                    {/if}
                </div>
                <div class="column">
                    <div class="infoitem">
                        <div class="infoitemtitle">Email:</div>
                        <div class="infoitemvalue">{profile.email}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Home Phone:</div>
                        <div class="infoitemvalue">{profile.home_phone ? formatPhoneNumber(profile.home_phone) : ''}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Mobile Phone:</div>
                        <div class="infoitemvalue">{profile.mobile_phone ? formatPhoneNumber(profile.mobile_phone) : ''}</div>
                    </div>
                    <!-- {#if profile.role === 'contractor' || profile.role === 'employee'}
                    <div class="infoitem">
                        <div class="infoitemtitle">Carrier:</div>
                        <div class="infoitemvalue">{profile.carrier}</div>
                    </div>
                    {/if} -->
                </div>
            </div>
        </div>
        <div class="section address">
            <div class="sectionsubtitle">Address</div>
            <div class="column">
                <div class="infoitem">
                    <div class="infoitemtitle">Street:</div>
                    <div class="infoitemvalue">{profile.address}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">City:</div>
                    <div class="infoitemvalue">{profile.city}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">State:</div>
                    <div class="infoitemvalue">{profile.state}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Zip Code:</div>
                    <div class="infoitemvalue">{profile.zipcode}</div>
                </div>
            </div>
        </div>
        {#if myself.plan_type !== 'basic' && profile.role === 'client'}
        <div class="section billininginfo">
            <div class="sectionsubtitle">Billing Information</div>
            <div class="billininginfotableholder">
                <table style="width: 100%;">
                    <tr>
                        <th>Type</th>
                        <th>Number</th>
                        <th>Expiry</th>
                    </tr>
                    {#each profile.paycards as paycard}
                    <tr>
                        <td style='text-transform: capitalize;'>{paycard.cc_brand}</td>
                        <td>{paycard.cc_number}</td>
                        <td>{paycard.cc_expiry}</td>
                        <td>
                            {#if paycard.is_default}
                                <div class='cc_default'>default</div>
                            {/if}
                        </td>
                    </tr>
                    {/each}
                </table>
            </div>
        </div>
        {/if}
        <!-- <div class="section map">
            <div class="sectionsubtitle">Map</div>
            <div class="mapholder">
                <GoogleMap
                    address={profile.address}
                    city={profile.city}
                    state={profile.state}
                    />
            </div>
        </div> -->

        {#if profile.role == 'contractor'}
        <div class="section crewinformation">
            <div class="sectionsubtitle">{'Crew Information'}</div>
            <div class="row">
                {#if profile.role === 'contractor' || (profile.role == 'applicant' && profile.profile_type.toLowerCase() === 'contractor')}
                <div class="column">
                    <div class="infoitem">
                        <div class="infoitemtitle">Business Structure:</div>
                        <div class="infoitemvalue">{profile.business_structure}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Has Experience?:</div>
                        <div class="infoitemvalue">{profile.has_experience ? 'Yes' : 'No'}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Years of Experience:</div>
                        <div class="infoitemvalue">{profile.years_experience}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Time Availability:</div>
                        <div class="infoitemvalue">{profile.time_availability}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Authorized to Work?:</div>
                        <div class="infoitemvalue">{profile.authorized ? 'Yes' : 'No'}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Insured:</div>
                        <div class="infoitemvalue">{profile.insured ? 'Yes' : 'No'}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">English Fluency?:</div>
                        <div class="infoitemvalue">{profile.english_fluency ? 'Yes' : 'No'}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Has a Truck?:</div>
                        <div class="infoitemvalue">{profile.has_truck ? 'Yes' : 'No'}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Internet Access?:</div>
                        <div class="infoitemvalue">{profile.internet_access ? 'Yes' : 'No'}</div>
                    </div>
                    <div class="infoitem">
                        <div class="infoitemtitle">Smart Phone?:</div>
                        <div class="infoitemvalue">{profile.smart_phone ? 'Yes' : 'No'}</div>
                    </div>
                </div>
                {/if}
                <div class="column">
                    {#if profile.role == 'contractor'}
                    <div class="infoitem">
                        <div class="infoitemtitle">How did you hear about us?:</div>
                        <div class="infoitemvalue">{profile.hear_about_us || ''}</div>
                    </div>
                    {/if}
                </div>
            </div>
        </div>
        {/if}
        <!-- {#if myself.plan_type !== 'basic' && (profile.role === 'client' || profile.role === 'contractor' || profile.role === 'employee' || profile.role === 'landscaper')}
        <div class="section services">
            <div class="sectionsubtitle">Services</div>
            <ResponsiveTable 
                table_data={services_data}
                statistic_data={statistic_data}
                num_per_page={100}
                show_csv_export={true}
                show_date_range={true}
                date_filter_param='d'
                init_type='one_user'
                refresh_user_info={refresh_user_info}
                bind:from_date={from_date}
                bind:to_date={to_date}
                bind:date_value={date_value}
                bind:table_header_config={services_table_header_config}
                bind:total_items={services_data.length} 
                bind:show_items={show_items}
            />
        </div>
        {/if}
        {#if myself.plan_type !== 'basic' && profile.role === 'client'}
        <div class="section invoices">
            <div class="sectionsubtitle">Invoices</div>
            <ResponsiveTable
                table_data={invoices_data}
                num_per_page={100}
                sort_functions={sort_functions}
                refresh_user_info={refresh_user_info}
                bind:table_header_config={invoices_table_header_config}
                bind:total_items={invoices_data.length}
                bind:show_items={invoice_show_items}
            />
        </div>
        {/if} -->

        <div class="buttonholder">
            {#if check_access_able(myself.role, profile.role)}
                <button class="reminder" on:click={() => { navigate("/edit_profile"); }}>
                    <i class="fas fa-edit"></i> Edit Profile
                </button>
                &nbsp;&nbsp;
            {/if}
        </div>
    </div>
    {:else}
    <Loading />
    {/if}
</div>


<style>
	.formholder {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
		.formholder {
			width: 90%;
		}
	}
	.pagetitle {
		border-bottom: solid 1px #E9E9EC;
		font-size: 3rem;
		font-weight: bold;
	}
    .buttonholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        grid-area: bh;
        margin-top: 10px;
    }
    .buttonholder button {
        padding-left: 20px;
        padding-right: 20px;
    }
    .buttonholder button.reminder{
        background-color: #ff9100;
        color: white;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .column{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .row{
        padding: 5px;
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        box-sizing: border-box;
    }
    .infoitem {
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 50%;
        max-width: 250px;
        text-align: left;
        font-weight: bold;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .basic {
        grid-area: ba;
    }
    .address {
        grid-area: ad;
    }
    .map {
        grid-area: ma;
        /* height: calc(100%+50px); */
        margin-bottom: 50px;
        /* padding: 0px; */
        width: 100%;
        height: 100%;
    }
    .crewinformation {
        grid-area: cr;
    }
    .services {
        grid-area: se;
    }
    .invoices {
        grid-area: in;
    }
    .billininginfo {
        grid-area: bi;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "ba ba ba ba ba ba ba ba ba ba ba ba"
                             /* "se se se se se se se se se se se se" */
                             "ad ad ad ad ad ad ma ma ma ma ma ma"
                             /* "co co co co co co ma ma ma ma ma ma" */
                             "cr cr cr cr cr cr cr cr cr cr cr cr"
                             "bi bi bi bi bi bi bi bi bi bi bi bi"
                             "bh bh bh bh bh bh bh bh bh bh bh bh"
                             "in in in in in in in in in in in in";
        gap: 20px;

    }
    .section {
        border: 1px solid #1769aa;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "bh"
                                 "ba"
                                 "se"
                                 /* "co" */
                                 "cr"
                                 "ad"
                                 "bi"
                                 "ma"
                                 "in";
            gap: 20px;

        }
        .services {
            grid-area: se;
            width: 100%;
            max-width: 100%;
            overflow-x: scroll;
        }
        .invoices {
            grid-area: in;
            width: 100%;
            max-width: 100%;
            overflow-x: scroll;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button {
            width: 100%;
        }
        .column{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .row{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .infoitem {
            width: 100%;
            display: flex;
            flex-direction: row;
        }
        .infoitem .infoitemtitle {
            width: 150px;
            font-weight: bold;
            text-align: right;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .infoitem .infoitemvalue {
            text-align: left;
            margin-left: 10px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
    }
    .cc_default {
        display: inline;
        background: lightgray;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
</style>